module.exports = __webpack_public_path__ + "static/media/face_cry.4f667b6b.svg";